import { useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import apiClient from '../../utils/api';

const AUTO_SYNC_INTERVAL_MS = 15 * 60 * 1000; // 15 minutes

function FitbitAutoSync() {
  const { user, loading } = useAuth();
  const intervalRef = useRef(null);

  useEffect(() => {
    if (loading || !user) return;

    const doAutoSync = () => {
      apiClient.post('/api/fitbit/auto-sync').catch(() => {
        // Best-effort — silently ignore errors
      });
    };

    // Sync on mount (app open)
    doAutoSync();

    // Sync when tab becomes visible again
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        doAutoSync();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    // Sync every 15 minutes while app is open
    intervalRef.current = setInterval(doAutoSync, AUTO_SYNC_INTERVAL_MS);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [user, loading]);

  return null;
}

export default FitbitAutoSync;
